import avatar from 'src/assets/svg/avatar.svg';
import imageCameraChange from 'src/assets/svg/cameraChange.svg';
import iconCircle1 from 'src/assets/svg/circle1.svg';
import iconDown from 'src/assets/svg/iconDown.svg';
import iconFilter from 'src/assets/svg/iconfilter.svg';
import iconMess from 'src/assets/svg/iconmess.svg';
import iconNoti from 'src/assets/svg/iconnoti.svg';
import iconPagiLeft from 'src/assets/svg/iconpagileft.svg';
import iconPagiRight from 'src/assets/svg/iconpagiright.svg';
import iconSearch from 'src/assets/svg/iconsearch.svg';
import iconStatus from 'src/assets/svg/iconstatus.svg';
import iconVali from 'src/assets/svg/iconvali.svg';
import imageBannerProfile from 'src/assets/svg/imageBannerProfile.png';
import iconLogo from 'src/assets/svg/logo-qlcv.png';
import iconFile from 'src/assets/svg/iconfile.svg';
import iconImage from 'src/assets/svg/iconimage.svg';
import imgprogress from 'src/assets/svg/imgprogress.svg';
import iconreview from 'src/assets/svg/iconreview.svg';
import imgcompleted from 'src/assets/svg/imgcompleted.svg';
import iconCommon from 'src/assets/svg/iconCommon.svg';
import iconworkflowy from 'src/assets/svg/iconworkflowy.svg';
import icondotCheck from 'src/assets/svg/dotCheck.svg';
import iconTableImg from 'src/assets/svg/iconTable.svg';
import iconsmile from 'src/assets/svg/iconsmile.svg';
import iconsend from 'src/assets/svg/iconsend.svg';
import iconimageupload from 'src/assets/svg/iconimageupload.svg';
import iconEmoji from 'src/assets/svg/iconEmoji.svg';
import icontable from 'src/assets/svg/iconTable.svg';
import iconrightdown from 'src/assets/svg/iconrightdown.svg';
import iconfilterdepartment from 'src/assets/svg/iconfilterdepartment.svg';
import arrowDown from 'src/assets/svg/arrowDown.svg';
import arrowUp from 'src/assets/svg/arrowUp.svg';
import icontodo from 'src/assets/svg/icontodo.svg';
import iconremoved from 'src/assets/svg/iconremoved.svg';
import iconTask from 'src/assets/svg/imgtask.svg';
import iconExcel from 'src/assets/svg/iconExcel.png';
import iconPdf from 'src/assets/svg/iconPdf.png';
import iconPowerPoint from 'src/assets/svg/iconPowerPoint.png';
import iconFileUpload from 'src/assets/svg/iconFile.png';

import iconDoubleUp from 'src/assets/svg/double-up.svg';
import iconPriorityMedium from 'src/assets/svg/priority-medium.svg';
import iconPriorityLow from 'src/assets/svg/priority-low.svg';

import React from 'react';

type Props = {
  className?: string | undefined;
  width?: number | undefined;
  height?: number | undefined;
  size?: number | undefined;
  color?: string | undefined;
  filter?: string | undefined;
  src?: string | undefined;
  onClick?: (
    event: React.MouseEvent<HTMLElement>,
  ) => void | undefined;
};
export const IconArrDown = ({
  className,
  onClick,
}: Props) => (
  <img
    src={arrowDown}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const IconArrUp = ({
  className,
  onClick,
}: Props) => (
  <img
    src={arrowUp}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const IconFilterDepartment = ({
  className,
  onClick,
}: Props) => (
  <img
    src={iconfilterdepartment}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const ImageCameraChange = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <img
    src={imageCameraChange}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const BannerProfile = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <img
    src={imageBannerProfile}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const SearchIcon = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <img
    src={iconSearch}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const IconCommon = ({
  className,
  onClick,
}: Props) => (
  <img
    src={iconCommon}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const Iconworkflowy = ({
  className,
  onClick,
}: Props) => (
  <img
    src={iconworkflowy}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const Imgstatus = ({
  className,
  onClick,
}: Props) => (
  <img
    src={imgprogress}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const Imgprogress = ({
  className,
  onClick,
}: Props) => (
  <img
    src={imgprogress}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const Imgcompleted = ({
  className,
  width,
  height,
  size,
  onClick,
}: Props) => (
  <img
    width={width}
    height={height}
    src={imgcompleted}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const Iconreview = ({
  className,
  onClick,
}: Props) => (
  <img
    src={iconreview}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const IconFile = ({ className, onClick }: Props) => (
  <img
    src={iconFile}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const IconImage = ({
  className,
  onClick,
}: Props) => (
  <img
    src={iconImage}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const IconExcel = ({ className, onClick }: Props) => (
  <img
    src={iconExcel}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const IconPdf = ({ className, onClick }: Props) => (
  <img
    src={iconPdf}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const IconPowerPoint = ({ className, onClick }: Props) => (
  <img
    src={iconPowerPoint}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const IconFileUpload = ({ className, onClick }: Props) => (
  <img
    src={iconFileUpload}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const IconImgDown = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <img
    src={iconDown}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const PlusIcon = ({
  className,
  width,
  height,
  size,
  color = `#2D2D2D`,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="fal fa-plus"
    onClick={onClick}
  ></i>
);
export const IconPaper = ({
  className,
  width,
  height,
  size,
  color = `#A7A7A7`,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="fal fa-paperclip"
  ></i>
);
export const IconLock = ({
  size,
  color = `#A7A7A7`,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="fas fa-lock-alt"
  ></i>
);
export const IconClock = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="far fa-clock"
  ></i>
);
export const MessIcon = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <img
    src={iconMess}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const NotiIcon = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <img
    src={iconNoti}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const AvatarIcon = ({
  className,
  width,
  height,
  src,
  size,
  color,
  onClick,
}: Props) => (
  <img
    src={src ?? avatar}
    style={{ width: width, height: height }}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const SuccessIcon = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => <i className="far fa-check-circle"></i>;
export const ArrowIcon = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i className="far fa-sign-out" onClick={onClick}></i>
);
export const ArrowRightIcon = ({
  className,
  width,
  height,
  size,
  color = '#959595',
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="far fa-angle-right"
    onClick={onClick}
  ></i>
);

export const Circle1Icon = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <img
    src={iconCircle1}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const BarIcon = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i className="far fa-list-ul" onClick={onClick}></i>
);

export const IconStartus = ({
  className,
  width,
  height,
  size,
  filter,
  color,
  onClick,
}: Props) => (
  <img
    src={iconStatus}
    style={{
      color: color,
      width: width,
      height: height,
      filter: filter,
    }}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const IconCalendar = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i
    style={{ color: color, fontSize: size }}
    className="far fa-calendar-alt"
    onClick={onClick}
  ></i>
);
export const IconArrowLeft = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => <i className="far fa-angle-double-left"></i>;
export const IconSetting = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => <i className="far fa-cog"></i>;
export const IconProject = ({
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="far fa-file-medical-alt"
  ></i>
);
export const IconSystem = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="far fa-sitemap"
  ></i>
);
export const IconUser = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="far fa-user-friends"
    onClick={onClick}
  ></i>
);

export const IconReport = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i className="far fa-chart-line" onClick={onClick}></i>
);
export const IconLogo = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <img
    src={iconLogo}
    style={{ width: width, height: height, }}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const IconTaskme = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i className="far fa-list-ul" onClick={onClick}></i>
);
export const IconDashboard = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i className="fas fa-th-large" onClick={onClick}></i>
);
export const IconHome = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i className="far fa-home" onClick={onClick}></i>
);

export const IconDepartment = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => <i className="far fa-code-branch"></i>;
export const IconDecentralization = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i className="far fa-shield-check" onClick={onClick}></i>
);

export const IconDatafield = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i className="far fa-sliders-v" onClick={onClick}></i>
);

export const IconBackground = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i className="far fa-image" onClick={onClick}></i>
);

export const IconFilter = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <img
    src={iconFilter}
    style={{ width: width, height: height }}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const IconTable = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="far fa-border-all"
    onClick={onClick}
  ></i>
);
export const IconTableImg = ({
  className,
  onClick,
}: Props) => (
  <img
    src={iconTableImg}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const IconArrowDown = ({ onClick }: Props) => (
  <i className="fas fa-caret-down" onClick={onClick}></i>
);
export const IconMore = ({
  className,
  width,
  height,
  size,
  color = `#959595`,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="far fa-ellipsis-h"
  ></i>
);
export const IconExclamation = ({
  className,
  width,
  height,
  size,
  color = '#A7A7A7',
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="fal fa-exclamation-circle"
    onClick={onClick}
  ></i>
);

export const IconPagiLeft = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <img
    src={iconPagiLeft}
    style={{ width: width, height: height }}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const IconPagiRight = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <img
    src={iconPagiRight}
    style={{ width: width, height: height }}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const IconVali = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <img
    src={iconVali}
    style={{ width: width, height: height }}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const IconMessDepartment = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i className="far fa-comment-dots" onClick={onClick}></i>
);

export const IconRedo = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="far fa-redo"
    onClick={onClick}
  ></i>
);
export const IconExclamationTrig = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="fal fa-exclamation-triangle"
    onClick={onClick}
  ></i>
);
export const IconServer = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="fal fa-server"
    onClick={onClick}
  ></i>
);
export const IconView = ({
  className,
  width,
  height,
  size,
  color = `#959595`,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="far fa-eye"
  ></i>
);
export const IconEdit = ({
  className,
  width,
  height,
  size,
  color = `#005AC4`,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="fas fa-pen"
    onClick={onClick}
  ></i>
);
export const IconDelete = ({
  className,
  width,
  height,
  size,
  color = `#F43C3C`,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="far fa-trash-alt"
    onClick={onClick}
  ></i>
);

export const IconEmail = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i className="far fa-envelope" onClick={onClick}></i>
);
export const IconUp = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color, height: height }}
    className="fas fa-sort-up"
    onClick={onClick}
  ></i>
);
export const IconDown = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color, height: height }}
    className="fas fa-sort-down"
    onClick={onClick}
  ></i>
);
export const IconTimeline = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="far fa-stream"
    onClick={onClick}
  ></i>
);

export const IconCamera = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color, height: height }}
    className="far fa-camera"
    onClick={onClick}
  ></i>
);

export const IconFilterLevel = ({
  size,
  color,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="far fa-sort-amount-up-alt"
    onClick={onClick}
  ></i>
);

export const IconFileAction = ({
  size,
  color,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="fas fa-file-download"
    onClick={onClick}
  ></i>
);
export const IconUserOne = ({
  size,
  color,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="far fa-user"
    onClick={onClick}
  ></i>
);

export const Icontable = ({
  className,
  onClick,
}: Props) => (
  <img
    src={icontable}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const Iconrightdown = ({
  className,
  onClick,
}: Props) => (
  <img
    src={iconrightdown}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const IconEmoji = ({
  className,
  onClick,
}: Props) => (
  <img
    src={iconEmoji}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const Iconsmile = ({
  className,
  onClick,
}: Props) => (
  <img
    src={iconsmile}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const Iconimageupload = ({
  className,
  onClick,
}: Props) => (
  <img
    src={iconimageupload}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const Iconsend = ({ className, onClick }: Props) => (
  <img
    src={iconsend}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const IconToDo = ({
  width,
  height,
  className,
  onClick,
}: Props) => (
  <img
    src={icontodo}
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const IconRemoved = ({
  width,
  height,
  className,
  onClick,
}: Props) => (
  <img
    src={iconremoved}
    width={width}
    height={height}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const IconTask = ({ className, onClick }: Props) => (
  <img
    src={iconTask}
    className={className}
    onClick={onClick}
    alt=""
  />
);
export const IconCategory = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="far fa-box"
  ></i>
);
export const IconAnalytics = ({
  className,
  width,
  height,
  size,
  color,
  onClick,
}: Props) => (
  <i
    style={{ fontSize: size, color: color }}
    className="far fa-analytics"
  ></i>
);

export const IconDoubleUp = ({
  className,
  onClick,
}: Props) => (
  <img
    src={iconDoubleUp}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const IconPriorityMedium = ({
  className,
  onClick,
}: Props) => (
  <img
    src={iconPriorityMedium}
    className={className}
    onClick={onClick}
    alt=""
  />
);

export const IconPriorityLow = ({
  className,
  onClick,
}: Props) => (
  <img
    src={iconPriorityLow}
    className={className}
    onClick={onClick}
    alt=""
  />
);
